module.exports = __webpack_public_path__ + "img/3.603931b4.png";